/*
 * Primitive spacing units.
 * These reflect the spacing units in the Figma design system.
 * Do not modify these spacing units without design system approval.
 */

export const spacingPrimitive = {
  0: 0,
  50: 2,
  100: 4,
  150: 6,
  200: 8,
  300: 12,
  400: 16,
  500: 20,
  600: 24,
  800: 32,
  1000: 40,
  1200: 48,
} as const;
